let discountAttrMain;

//Code used for open popup
const popupOpen = document.querySelector('.builder-tag .popup-main-wrapper');

if (popupOpen) {
    const togglePopup = (action) => popupOpen.classList[action]('active');

    document.querySelector('.top-bundle .info-icons')?.addEventListener('click', () => {
      togglePopup('add');
    });
    
    document.querySelector('.builder-tag .close-popup-button')?.addEventListener('click', () => togglePopup('remove'));
    document.querySelector('.modal-popup__overlay')?.addEventListener('click', () => togglePopup('remove'));
}


// Code used for smooth scroll

const collectionButtons = document.querySelectorAll('.multi-collections .title-collection');
const collectionComponents = document.querySelectorAll('.multi-collections .slider-mobile-gutter');
const headerHeight = document.querySelector('.header-wrapper').offsetHeight;

let activeComponent = null;

collectionButtons.forEach((button) => {
    button.addEventListener('click', function () {
        const buttonSet = button.getAttribute('data-title');
        if (buttonSet) {
            collectionComponents.forEach((component) => {
                if (component.getAttribute('data-collection') === buttonSet) {
                    if (activeComponent && activeComponent !== component) {
                        activeComponent.style.marginTop = '0px';
                    }
                    component.style.marginTop = '20px';
                    const componentTop = component.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({ 
                        top: componentTop - headerHeight - 50,
                        behavior: 'smooth' 
                    });
                    activeComponent = component;
                }
            });
        }
    });
});

//Bundle builder js start discount message

setInterval(() => {
    const totalCount = document.querySelector('.bundle-table');
    const messageElement = document.querySelector('.discount_message_shows');
    let messageShowset = document.querySelectorAll('.discount-show-message-set');

    let tableCount = document.querySelector('.save_more .bundle-table');
    let topBarsection = document.querySelector('.save_more .top-heading .page-layout');
    const UpdationText = document.querySelector('.innertext-updation');
    let newAttributeName = 'data-total-from-table';

      if (tableCount && topBarsection) {
        let totalValue = parseInt(tableCount.getAttribute('data-count-total'), 10);
        discountAttrMain = totalValue;
        if (!isNaN(totalValue)) {
          topBarsection.setAttribute(newAttributeName, totalValue);
          let messageTopBar = '';

          if (totalValue >= 7) {
            messageTopBar = `<span class="discount-color-set line-sets" style="color: #fff;">You're at maximum discount of 20% off</span>`;
          } else if (totalValue >= 5) {
            messageTopBar = `<span class="discount-color-sets">You get 15% off.</span> <span class="discount-color line-set">Add ${7 - totalValue} items to save 20%.</span>`;
          } else if (totalValue >= 3) {
            messageTopBar = `<span class="discount-color-sets">You get 10% off.</span> <span class="discount-color line-set">Add ${5 - totalValue} items to save 15%.</span>`;
          } else if (totalValue > 0 && totalValue < 3) {
            messageTopBar = `<span class="discount-color-sets">Add ${3 - totalValue} items for 10% OFF.</span> <span class="discount-color line-set">Add more for up to 20%.</span>`;
          } else if (totalValue === 0) {
            messageTopBar = `<span class="discount-color-sets">Add 3 items for 10% OFF.</span> <span class="discount-color line-set">Add more for up to 20%.</span>`;
          }
          if (UpdationText) {
            UpdationText.innerHTML = messageTopBar;
          }
        }
      }
  
    if (totalCount && messageElement && messageShowset) {

      const currentCount = parseInt(totalCount.getAttribute('data-count-total'));

      previousCount = currentCount;
  
      let message = '';
      let messageSet = '';
     
      if (currentCount >= 7) {
        message = `<span class="discount-color-set line-set">You're at maximum discount of 20% off</span>`;
        messageSet = `<span>You get 20% off.</span>`;

      } else if (currentCount >= 5) {
        message = `<span class="discount-color-set">You get 15% off.</span> <span class="discount-color line-set">Add ${7 - currentCount} items to save 20%.</span>`;
        messageSet = `<span>You get 15% off.</span>`;
      } else if (currentCount >= 3) {
        message = `<span class="discount-color-set">You get 10% off.</span> <span class="discount-color line-set">Add ${5 - currentCount} items to save 15%.</span>`;
        messageSet = `<span>You get 10% off.</span>`;
      } else if (currentCount > 0 && currentCount < 3) {
        message = `<span class="discount-color-set">Add ${3 - currentCount} items for 10% OFF.</span> <span class="discount-color line-set">Add more for up to 20%.</span>`;
      } else if (currentCount === 0) {
        message = `<span class="discount-color-set">Add 3 items for 10% OFF.</span> <span class="discount-color line-set">Add more for up to 20%.</span>`;
      }
  
      messageElement.innerHTML = message;
      if (messageShowset.length > 0) {
            messageShowset.forEach(el => {
                el.innerHTML = messageSet;
            });
        }
    }
  }, 500);

  async function bindRemoveCartItemEvents() {
    const forms = document.querySelectorAll('.remove-cart-item-form');
  
    forms.forEach(form => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
  
        const formData = new FormData(form);
  
        try {
         
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });
  
         
          const response = await fetch(window.location.pathname + '?section_id=footer-mini-cart');
          const text = await response.text();
          const html = new DOMParser().parseFromString(text, 'text/html');
  
          
          const newCart = html.querySelector('#footer-mini-cart');
          const oldCart = document.querySelector('#footer-mini-cart');
          if (newCart && oldCart) {
            oldCart.innerHTML = newCart.innerHTML;
          }
  
          // Re-bind events
          bindRemoveCartItemEvents();
          //filterMicroCartItems();
  
        } catch (error) {
          console.error('Cart update error:', error);
        }
      });
    });
  }

  function filterMicroCartItems() {
    const addMoreSaveMore = document.querySelector('.micro-cart__items');
    if (addMoreSaveMore) {
      const encapsulatedBlocks = addMoreSaveMore.querySelectorAll('.micro-cart__item.encapsulated-block');
      if (encapsulatedBlocks.length == 1) {
        encapsulatedBlocks[0].style.display = 'none';
      }else{
        encapsulatedBlocks[0].style.display = 'flex';
      }
      if (encapsulatedBlocks.length >= 2) {
        const startBlock = encapsulatedBlocks[encapsulatedBlocks.length - 2];
        const endBlock = encapsulatedBlocks[encapsulatedBlocks.length - 1];
        const allMicroCartItems = addMoreSaveMore.querySelectorAll('.micro-cart__item');
        
        const microCartItemsToShow = [];
        let current = startBlock;
        
        while (current && current !== endBlock) {
          if (current.classList.contains('micro-cart__item')) {
            microCartItemsToShow.push(current);
          }
          current = current.nextElementSibling;
        }
        allMicroCartItems.forEach(item => {
          if (microCartItemsToShow.includes(item)) {
            item.style.display = 'flex';
          } else {
            item.style.display = 'none';
          }
        });
        console.log(current);
      }
    }
  }

  function initEncapsulatedToggle() {
    const encapsulated_items = document.querySelector('.encapsulated-block');
    const itemShow = document.querySelectorAll('.micro-cart__wrapper li.micro-cart__item');
    const hideItems = document.querySelector('.hide-bundles');

    function showHiddenItemsOnly() {
      itemShow.forEach((item) => {
        if (getComputedStyle(item).display === 'none') {
          item.style.display = 'flex';
        }
      });
      if (hideItems) hideItems.style.display = 'flex';
      if (encapsulated_items) encapsulated_items.style.display = 'none';
    }

    function hideVisibleItemsOnly() {
      itemShow.forEach((item) => {
        if (getComputedStyle(item).display === 'flex') {
          item.style.display = 'none';
        }
      });
      if (hideItems) hideItems.style.display = 'none';
      if (encapsulated_items) encapsulated_items.style.display = 'flex';
    }
  
    if (encapsulated_items) {
      encapsulated_items.addEventListener('click', showHiddenItemsOnly);
    }
  
    if (hideItems) {
      hideItems.addEventListener('click', hideVisibleItemsOnly);
    }
  }
  
  
  initEncapsulatedToggle();

  // document.addEventListener('DOMContentLoaded', window.filterMicroCartItems);

  document.addEventListener("DOMContentLoaded", (event) => {
    document.body.addEventListener("click", function (event) {
      if (event.target.classList.contains("remove-item_btn")) {
        setTimeout(() => {
          // location.reload()
          window.location.href = '/pages/add-more-save-more';
        }, 3000);
      }
    }); 
  });


  function printMessage() {
    let modalMessage = document.querySelectorAll('.wrapper-discount-title-show .discount-message-showing');
    if (modalMessage) {
      modalMessage.forEach((modalDiscount) => {
        // let discountCode = parseInt(modalDiscount.getAttribute('data-count-items-products'), 10);
        let discountCode =  discountAttrMain;
        let message = '';
  
        if (discountCode >= 7) {
          message = `<span class="discount-color-set line-set">You get 20% off</span>`;
        } else if (discountCode >= 5) {
          message = `<span class="discount-color-set">You get 15% off.</span>`;
        } else if (discountCode >= 3) {
          message = `<span class="discount-color-set">You get 10% off.</span>`;
        } else if (discountCode > 0 && discountCode < 3) {
          message = `<span class="discount-color-set">Add ${3 - discountCode} items for 10% OFF.</span>`;
        } else {
          // message = `<span class="discount-color-set">Add 3 items for 10% OFF.</span> <span class="discount-color line-set">Add more for up to 20%.</span>`;
          message = `<span class="discount-color-set">Add 3 items for 10% OFF.</span>`;
        }
  
        const messageBox = modalDiscount.querySelector('.discount-message-popup-shows-h0');
        if (messageBox) {
          messageBox.innerHTML = message;
        }
      });
    }

  }
  
  document.addEventListener("DOMContentLoaded",window.printMessage);